export class ResetPasswordRequestRequest {
    constructor(
        public username: string
    ){}
}
